import { useEffect } from 'react';

import { useHost } from '@xing-com/crate-xinglet';
import { useTagManager } from '@xing-com/winery-tag-manager';

import { useUserHashedEmail } from '../use-user-hashed-email/use-user-hashed-email';

export const useWineryTagManager = (
  options?: Record<string, unknown>
): void => {
  const { isPreview } = useHost();
  const { userHashedEmail, isUserHashedEmailLoading } = useUserHashedEmail();
  const env = isPreview ? 'preview' : 'production';
  const { initializeTagManagerOnce } = useTagManager({ env });

  useEffect(() => {
    if (!isUserHashedEmailLoading) {
      initializeTagManagerOnce({ bid: userHashedEmail, options });
    }
  }, [
    userHashedEmail,
    initializeTagManagerOnce,
    isUserHashedEmailLoading,
    options,
  ]);
};
